import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class ProcessingCodeFilter extends Component {
    state = {
        processingCodeLists:[],
        processingCodeValue: '',
        isprocessingCodeLoading: true
    };
    componentDidMount(){
        this.getprocessingCode(this.props.start_date,this.props.end_date);
    }
    restprocessingCodeFilter(start_date, end_date) {
        this.setState({
            processingCodeValue: [],
        })
    }
    getprocessingCode(start_date, end_date){

    this.setState({
    processingCodeLists:[],
        processingCodeValue: [],
        isprocessingCodeLoading: true
    })
        axios.get(config.get('API_URL')+'/filters/get_processing_code/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                start_date: start_date,
                end_date: end_date
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((tender_mode, index) => {
                    this.state.processingCodeLists.push({value: tender_mode.processing_code, label: tender_mode.processing_code})
                });
            }
            this.setState({
                isprocessingCodeLoading: false
            })
        });

    }


    changeprocessingCode(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.processingCodeLists.findIndex(obj => obj.value==ids.value);
                this.state.processingCodeLists.move(index,0).join(',');
            });
        }
        this.props.onSelectprocessingCode(optionSelected, tenderArray);
        this.setState({
            processingCodeValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="tender_mode"
                isMulti
                value={this.state.processingCodeValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeprocessingCode.bind(this)}
                options={this.state.processingCodeLists}
                placeholderButtonLabel="Select [Processing Code]"
                isLoading={this.state.isprocessingCodeLoading}
            />
        );

    }
}
export default ProcessingCodeFilter;